import { queryOptions, useQuery } from '@tanstack/react-query';

import API from '@api';
import { withSsrCache } from '../../ssrCache';

/** Зоны бесплатной доставки (/delivery) — справочник, меняется редко */
const AREAS_STALE_TIME = 10 * 60 * 1000;
const AREAS_GC_TIME = 15 * 60 * 1000;

export const rangesQueryOptions = () =>
  withSsrCache(
    queryOptions({
      queryKey: ['ranges'],
      queryFn: () => API.getRanges(),
      select: res => res.getRanges ?? [],
      staleTime: AREAS_STALE_TIME,
      gcTime: AREAS_GC_TIME
    })
  );

export const useRangesQuery = () => useQuery(rangesQueryOptions());

export const rangeByIdQueryOptions = (titleShort: string) =>
  withSsrCache(
    queryOptions({
      queryKey: ['range', titleShort],
      queryFn: () => API.getRangeById({ title_short: titleShort }),
      select: res => res.getRangeById ?? null,
      staleTime: AREAS_STALE_TIME,
      gcTime: AREAS_GC_TIME,
      // Ошибка означает несуществующую зону — страница сразу уходит на /404,
      // ретраи только задержали бы редирект
      retry: false
    })
  );

export const useRangeByIdQuery = (titleShort: string) =>
  useQuery({ ...rangeByIdQueryOptions(titleShort), enabled: !!titleShort });
